export default "__VITE_ASSET__0_O6xQtr__"